export const CoreDeploymentQueryKeys = {
  all: () => ["core-deployments"],
  detail: (id: string) => ["core-deployments", id],
  overview: (id: string) => ["core-deployments", id, "overview"],
};
